import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 统计数据
 */
const quantity = {
  /**
   * 查询统计量
   */
  getQuantity(
    measureId,
    startTime,
    endTime,
    pointCode,
    pointNumber,
    segmentId
  ) {
    return axios.post(
      base.quantity.getQuantity,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        endTime,
        pointCode,
        pointNumber,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantity2(measures, startTime, endTime, segmentId) {
    startTime = startTime.replace(/-/g, "/");
    endTime = endTime.replace(/-/g, "/");
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantity2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySum(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySum,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumHour(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumHour,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumDay(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumDay,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumWeek(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumWeek,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumMonth(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumMonth,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumYear(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumYear,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySum2(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySum2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumHour2(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumHour2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumDay2(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumDay2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumWeek2(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumWeek2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumMonth2(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumMonth2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantitySumYear2(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantitySumYear2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityHour(
    measureId,
    startTime,
    endTime,
    pointCode,
    pointNumber,
    segmentId
  ) {
    return axios.post(
      base.quantity.getQuantityHour,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        endTime,
        pointCode,
        pointNumber,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityMonth(
    measureId,
    startTime,
    endTime,
    pointCode,
    pointNumber,
    segmentId
  ) {
    return axios.post(
      base.quantity.getQuantityMonth,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        endTime,
        pointCode,
        pointNumber,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityYear(
    measureId,
    startTime,
    endTime,
    pointCode,
    pointNumber,
    segmentId
  ) {
    return axios.post(
      base.quantity.getQuantityYear,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        endTime,
        pointCode,
        pointNumber,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityHour2(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantityHour2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityMonth2(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantityMonth2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityYear2(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantityYear2,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityHour3(
    measureId,
    startTime,
    span,
    pointCode,
    pointNumber,
    segmentId
  ) {
    return axios.post(
      base.quantity.getQuantityHour3,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        span,
        pointCode,
        pointNumber,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityMonth3(
    measureId,
    startTime,
    span,
    pointCode,
    pointNumber,
    segmentId
  ) {
    return axios.post(
      base.quantity.getQuantityMonth3,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        span,
        pointCode,
        pointNumber,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityYear3(
    measureId,
    startTime,
    span,
    pointCode,
    pointNumber,
    segmentId
  ) {
    return axios.post(
      base.quantity.getQuantityYear3,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        span,
        pointCode,
        pointNumber,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityDay(
    measureId,
    startTime,
    endTime,
    segments,
    pointCode,
    pointNumber
  ) {
    return axios.post(
      base.quantity.getQuantityDay,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        endTime,
        segments,
        pointCode,
        pointNumber,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityWeek(
    measureId,
    startTime,
    endTime,
    segments,
    pointCode,
    pointNumber
  ) {
    return axios.post(
      base.quantity.getQuantityWeek,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        endTime,
        segments,
        pointCode,
        pointNumber,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityDay2(
    measureId,
    startTime,
    span,
    segments,
    pointCode,
    pointNumber
  ) {
    return axios.post(
      base.quantity.getQuantityDay2,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        span,
        segments,
        pointCode,
        pointNumber,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityWeek2(
    measureId,
    startTime,
    span,
    segments,
    pointCode,
    pointNumber
  ) {
    return axios.post(
      base.quantity.getQuantityWeek2,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        span,
        segments,
        pointCode,
        pointNumber,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityDay3(measures, startTime, endTime, span, segments) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantityDay3,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        span,
        segments,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityWeek3(measures, startTime, endTime, span, segments) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantityWeek3,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        span,
        segments,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityDay4(
    measureId,
    startTime,
    endTime,
    pointCode,
    pointNumber,
    segmentId
  ) {
    return axios.post(
      base.quantity.getQuantityDay4,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        endTime,
        pointCode,
        pointNumber,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityWeek4(
    measureId,
    startTime,
    endTime,
    pointCode,
    pointNumber,
    segmentId
  ) {
    return axios.post(
      base.quantity.getQuantityWeek4,
      utils.postParamsArrayToJsonString({
        measureId,
        startTime,
        endTime,
        pointCode,
        pointNumber,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityDay5(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantityDay5,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 查询统计量
   */
  getQuantityWeek5(measures, startTime, endTime, segmentId) {
    if (measures instanceof Array) {
      measures = JSON.stringify(measures);
    }
    return axios.post(
      base.quantity.getQuantityWeek5,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
      })
    );
  },
  /**
   * 根据分类分组查用量
   */
  getQuantityByClassHour(
    viewNodesId,
    withoutThisNode,
    classFilter,
    expressionName,
    startTime,
    endTime
  ) {
    return axios.post(
      base.quantity.getQuantityByClassHour,
      utils.postParamsArrayToJsonString({
        viewNodesId,
        withoutThisNode,
        classFilter,
        expressionName,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 根据分类分组查用量
   */
  getQuantityByClassDay(
    viewNodesId,
    withoutThisNode,
    classFilter,
    expressionName,
    startTime,
    endTime
  ) {
    return axios.post(
      base.quantity.getQuantityByClassDay,
      utils.postParamsArrayToJsonString({
        viewNodesId,
        withoutThisNode,
        classFilter,
        expressionName,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 根据分类分组查用量
   */
  getQuantityByClassMonth(
    viewNodesId,
    withoutThisNode,
    classFilter,
    expressionName,
    startTime,
    endTime
  ) {
    return axios.post(
      base.quantity.getQuantityByClassMonth,
      utils.postParamsArrayToJsonString({
        viewNodesId,
        withoutThisNode,
        classFilter,
        expressionName,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 根据分类分组查用量
   */
  getQuantityByClassYear(
    viewNodesId,
    withoutThisNode,
    classFilter,
    expressionName,
    startTime,
    endTime
  ) {
    return axios.post(
      base.quantity.getQuantityByClassYear,
      utils.postParamsArrayToJsonString({
        viewNodesId,
        withoutThisNode,
        classFilter,
        expressionName,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 根据分类分组查用量
   */
  getQuantityByClassHour2(
    measuresId,
    withoutThisNode,
    container,
    classFilter,
    expressionName,
    startTime,
    endTime
  ) {
    return axios.post(
      base.quantity.getQuantityByClassHour2,
      utils.postParamsArrayToJsonString({
        measuresId,
        withoutThisNode,
        container,
        classFilter,
        expressionName,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 根据分类分组查用量
   */
  getQuantityByClassDay2(
    measuresId,
    withoutThisNode,
    container,
    classFilter,
    expressionName,
    startTime,
    endTime
  ) {
    return axios.post(
      base.quantity.getQuantityByClassDay2,
      utils.postParamsArrayToJsonString({
        measuresId,
        withoutThisNode,
        container,
        classFilter,
        expressionName,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 根据分类分组查用量
   */
  getQuantityByClassMonth2(
    measuresId,
    withoutThisNode,
    container,
    classFilter,
    expressionName,
    startTime,
    endTime
  ) {
    return axios.post(
      base.quantity.getQuantityByClassMonth2,
      utils.postParamsArrayToJsonString({
        measuresId,
        withoutThisNode,
        container,
        classFilter,
        expressionName,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 根据分类分组查用量
   */
  getQuantityByClassYear2(
    measuresId,
    withoutThisNode,
    container,
    classFilter,
    expressionName,
    startTime,
    endTime
  ) {
    return axios.post(
      base.quantity.getQuantityByClassYear2,
      utils.postParamsArrayToJsonString({
        measuresId,
        withoutThisNode,
        container,
        classFilter,
        expressionName,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 重新冻结数据
   */
  refreezeQuantity(measuresId, pointCode, pointNumber, startTime, endTime) {
    return axios.post(
      base.quantity.refreezeQuantity,
      utils.postParamsArrayToJsonString({
        measuresId,
        pointCode,
        pointNumber,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 重新冻结数据
   */
  refreezeQuantity2(companyId, pointCode, pointNumber, startTime, endTime) {
    return axios.post(
      base.quantity.refreezeQuantity2,
      utils.postParamsArrayToJsonString({
        companyId,
        pointCode,
        pointNumber,
        startTime,
        endTime,
      })
    );
  },
  getSpentMoneyDay(measures, startTime, endTime, segmentId, energyType = 1) {
    return axios.post(
      base.quantity.getSpentMoneyDay,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
        energyType,
      })
    );
  },
  getSpentMoneyMonth(measures, startTime, endTime, segmentId, energyType = 1) {
    return axios.post(
      base.quantity.getSpentMoneyMonth,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
        energyType,
      })
    );
  },
  getSpentMoneyYear(measures, startTime, endTime, segmentId, energyType = 1) {
    return axios.post(
      base.quantity.getSpentMoneyYear,
      utils.postParamsArrayToJsonString({
        measures,
        startTime,
        endTime,
        segmentId,
        energyType,
      })
    );
  },
};

export default quantity;
